module.exports = __webpack_public_path__ + "img/3.8bb4a5ff.jpg";